import React from 'react'

import Card from 'react-bootstrap/Card'

import '../MarketplaceWrapper/marketplace.scss'

export default function MarketplacePlaceholder({
  title,
  description,
  icon = '🚧',
}) {
  return (
    <Card body className="card--sm">
      <div className="marketplace-placeholder">
        <div className="marketplace-placeholder__icon" aria-hidden>
          {icon}
        </div>
        <h2 className="marketplace-placeholder__title">{title}</h2>
        <p className="marketplace-placeholder__desc">{description}</p>
      </div>
    </Card>
  )
}
